module.exports = __webpack_public_path__ + "static/media/brennenweb.bfacd669.png";